import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import { Modal, Button} from 'react-bootstrap';
import AppConstant from '../../../constants/app';


class RenderUploadLinksForm  extends Component {

  state = {
    fileLoaded: false,
    errorMessage: '',
    notice: null,
    noticeClassName: null
  }  

  onFormSubmit = (e) => {
    e.preventDefault();


    const acceptedExtensions = ['XLS', 'XLSX', 'CSV'];
    const fileValue = e.target.links.value || this.state.fileName;
    const extension = fileValue.split('.').pop().toUpperCase();
    const validExtension = acceptedExtensions.includes(extension);

    if(!validExtension) {
      this.setState({ 
        notice: 'Allowed Extensions : XSL, XSLX, CSV',
        noticeClassName: 'error-message'
      });

      return;
    }

    const file = e.target.links.files[0] || this.state.file;
    const deleteExisting = e.target.delete_existing.checked;
    const token = localStorage.getItem('token');
    const formData = new FormData();

    formData.append('import', file);

    if(e.target.delete_existing.checked) {
        formData.append('delete_existing', deleteExisting);
    }

    axios({ 
      method: 'post',
      url: `${AppConstant.API_URL}/link/mass/create?access_token=${token}`,
      config: { headers: {'Content-Type': 'multipart/form-data' }},
      data:  formData
    }).then(resp => {
      if (resp.status === 200) {
        this.setState({ 
          notice: resp.data.message, 
          noticeClassName: 'links-upload-success-message' 
        }, () => {
          setTimeout(() => {
            this.props.onToggleModal()
            window.location.reload();
          }, 2000)
        })
      }
    });
  }

  onDrop = (acceptedFiles) => {
    this.setState({
      fileLoaded: true,
      file: acceptedFiles[0],
      fileName: acceptedFiles[0].name,
    })
  }
  
  render () {
    const { onToggleModal } = this.props;
    return (
      <form onSubmit={this.onFormSubmit} className="links-upload-form">
      Please download the <a href={`${AppConstant.APP_URL}/myfiu_links.xlsx`}>myfiu_links.xlsx</a> file to see the structure
        <Dropzone
          className="dropzone"
          accept=""
          onDrop={this.onDrop}
          multiple={false}
          name= 'links'
        >
          <p>
            {this.state.fileLoaded ? `File loaded: ${this.state.fileName}` : 'Drag and drop file here'}
          </p>
          <p>or</p>
          <div className="input-upload">Browse file</div>
        </Dropzone>
        <hr />
        <div className={this.state.noticeClassName}>{this.state.notice}</div>
        <div>
          <label>
            <input type="checkbox" name="delete_existing" /> Delete all existing links
          </label>
        </div>
        <Modal.Footer>
            <Button
              type="button"
              className="cancel-btn"
              onClick={onToggleModal}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="accept-btn"
            >
              Accept
            </Button>
          </Modal.Footer>
      </form>
    )
  }
}

export default RenderUploadLinksForm;


// WEBPACK FOOTER //
// ./src/app/screens/links/uploadLinksForm.js